export const typeOfTimeSheetReportDropDown=[
  {
    value:"",
    label:"Select.."

  },
    {
        value:"Billable",
        label:"Billable"
    },
    {
        value:"Non Billable",
        label:"Non Billable"
    }, 
  
]